import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import classNames from 'classnames';
import EruptingMessageBlockData from '../../../Models/Content/EruptingMessageBlockData';
import {ImageProps, getImageProps} from 'app/utilities/ImageProps';

const BANNER_TIME_KEY = 'BANNER_TIME';

type BannerData = {
  image: ImageProps;
  title: string;
  subTitle: string;
  buttonLinkTitle: string;
  buttonLink: string;
};

type StorageTime = {
  timestamp: string;
};

const datesAreOnSameDay = (first: Date, second: Date) =>
  first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

const getBannerTime = () => {
  if (window.localStorage) {
    const timeObject: StorageTime = JSON.parse(localStorage.getItem(BANNER_TIME_KEY));
    if (!timeObject) return null;
    return new Date(parseInt(timeObject.timestamp));
  }
};
const setBannerTime = () => {
  const timeObject: StorageTime = {
    timestamp: new Date().getTime().toString(),
  };
  if (window.localStorage)
    localStorage.setItem(BANNER_TIME_KEY, JSON.stringify(timeObject));
};

const EruptingMessageBlock = ({data, context}: ComponentProps<EruptingMessageBlockData>) => {
  const [showBanner, setShowBanner] = useState(false);

  const item: BannerData = {
    image: getImageProps(data.image, context),
    title: data.title?.value,
    subTitle: data.subtitle?.value,
    buttonLink: data.buttonLink?.value,
    buttonLinkTitle: data.buttonLink?.value,
  };

  const isShowBanner = () => {
    const now = new Date();
    const lastTime = getBannerTime();
    if (lastTime && datesAreOnSameDay(now, lastTime)) {
      return false;
    } else {
      setBannerTime();
      return true;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowBanner(isShowBanner());
    }, 1000);
  }, []);

  return (
    <div className={classNames('EruptingMessageBlock', {show: showBanner})}>
      <Image className='EruptingMessageBlock__image' {...item.image} />
      <div className='EruptingMessageBlock__description'>
        <div className='EruptingMessageBlock__title'>{item.title}</div>
        {item.subTitle && <div className='EruptingMessageBlock__subtitle'>{item.subTitle}</div>}
        {item.buttonLink != null && item.buttonLinkTitle != '' && (
          <a className='EruptingMessageBlock__button' href={item.buttonLink}>
            {item.buttonLinkTitle}
          </a>
        )}
      </div>
    </div>
  );
};

export default EruptingMessageBlock;
